import {
  START_LOADING, GET_CONSULTANTS_FUNCTIONS,
  DELETE_CONSULTANT_FUNCTION, EDIT_CONSULTANT_FUNCTION, CREATE_CONSULTANT_FUNCTION,
  STOP_LOADING, ERROR,
  ACCESS_RIGHT_ERROR
} from "../consultantAction/types";


const INITIAL_STATE = {
  loading: false,
  success: false,
  message_valid: false
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_CONSULTANTS_FUNCTIONS:
      return {
        ...state,
        consultant_list: action.payload,
        loading: false,
        success: false
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case CREATE_CONSULTANT_FUNCTION:
      return {
        ...state,
        new_consultant: action.payload,
        loading: false
      }
    case EDIT_CONSULTANT_FUNCTION:
      return {
        ...state,
        edited_function: action.payload,
        loading: false
      }
    case DELETE_CONSULTANT_FUNCTION:
      return {
        ...state,
        success: true,
        loading: false
      }
    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }
    case ERROR:
      return {
        ...state,
        error_message: action.payload,
        message_valid: !state.message_valid,
        loading: false
      }
    case ACCESS_RIGHT_ERROR:
      return {
        ...state,
        access_error: action.payload,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
}